import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 21.76 21.76"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M18.59 3.19c-4.25-4.25-11.16-4.25-15.41 0C1.13 5.24 0 7.97 0 10.89s1.13 5.66 3.18 7.71c2.04 2.04 4.76 3.16 7.66 3.16h.07a10.77 10.77 0 0 0 7.69-3.27c4.22-4.22 4.22-11.09 0-15.31Zm-1.16 14.17c-1.73 1.78-4.05 2.76-6.54 2.78-2.51.01-4.81-.94-6.56-2.69s-2.7-4.07-2.7-6.55.96-4.81 2.7-6.55 4.18-2.71 6.55-2.71 4.75.9 6.55 2.71c3.58 3.58 3.58 9.42 0 13.01"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M16.19 12.45c-.41-.31-.88-.66-1.46-1.01-.86-.52-1.87-.43-2.49.17l-.09.07c-.43-.31-.8-.63-1.17-1s-.73-.79-1.01-1.16l.05-.06c.33-.33.54-.79.58-1.26.05-.51-.1-.98-.42-1.34-.33-.54-.66-.98-.99-1.42-.36-.45-.94-.72-1.55-.73-.62 0-1.15.24-1.55.69l-.41.41c-1.01 1.01-1.23 2.47-.63 4.1.48 1.31 1.47 2.73 2.8 3.99.95.95 2.43 2.21 4.05 2.78.58.21 1.13.31 1.65.31.96 0 1.81-.35 2.5-1.04l.43-.43c.45-.45.67-1.09.59-1.72-.08-.6-.41-1.1-.9-1.38ZM7.24 6.4c.13-.15.3-.18.39-.18.15 0 .3.06.38.16.32.42.62.83.92 1.33l.11.14c.06.06.06.16.05.21a.5.5 0 0 1-.15.33l-.5.61c-.2.25-.22.59-.06.86.34.56.89 1.25 1.52 1.88.56.56 1.13 1.02 1.85 1.5.27.18.63.17.89-.04l.6-.49c.19-.19.49-.12.7 0 .52.31.94.62 1.33.92l.09.06c.15.09.2.22.21.31a.55.55 0 0 1-.16.45l-.43.43c-.64.64-1.49.77-2.58.38-1.06-.38-2.3-1.24-3.5-2.44-1.17-1.12-2.03-2.34-2.43-3.43s-.3-1.93.28-2.52l.48-.48Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }